// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	margin: 0;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
		'Droid Sans', 'Helvetica Neue', sans-serif;
	font-size: 16px;
	overflow-x: hidden;
}

* {
	box-sizing: border-box;
	font-size: 16px;
	font-family: 'Noto Sans', sans-serif;
	vertical-align: none;
}

img,
svg {
	-webkit-user-select: none;
	user-select: none;
}

a {
	text-decoration: none;
}

button,
input {
	border: none;
	outline: none;
	transition: 0.3s all;
}

h1,
h2,
h3,
h4 {
	margin: 0;
}

.container {
	margin: 0 10.31rem;
}

.block__title {
	color: var(--accent-color, #956446);

	/* H2 */
	font-family: 'Cormorant';
	font-size: 2.8125rem;
	font-style: normal;
	font-weight: 600;
	line-height: normal;

	display: flex;
	align-items: center;
	gap: 1.5rem;
}

.title__line {
	width: 4.375rem;
	height: 0.0925rem;

	background: var(--accent-color, #956446);
}

.block__text {
	color: var(--accent-color, #956446);

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1.2rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

textarea:focus,
textarea:active,
input:focus {
	outline: none;
}
.input {
	color: var(--ui-accent, #875b52);
	width: 100%;
	background: none;
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */

	border-bottom: 0.0625rem solid var(--accent-color);
	padding: 0.31rem 0;
}

.input__error {
	color: var(--ui-accent, #875b52);
	width: 100%;
	background: none;
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */

	border-bottom: 0.0625rem solid var(--red-color);
	padding: 0.31rem 0;
}

.block__page {
	padding: 14rem 10.31rem 6.25rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 3.2rem;
}

.block__page_text {
	width: 100%;
	display: flex;
	flex-direction: column;

	gap: 1.5rem;

	color: var(--accent-color, #875b52);

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

.dot__list {
	margin-left: 2rem;
}

.underline__text {
	text-decoration: underline;
}

.alice-carousel {
	position: relative;
	width: 100%;
	margin: auto;
	direction: ltr;

	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
	user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.alice-carousel__stage {
	position: relative;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
	white-space: nowrap;
	transform-style: flat;
	-webkit-transform-style: flat;
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;
}
.alice-carousel__stage-item {
	position: relative;
	display: inline-block;
	padding: 0;
	margin: 0;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	padding: 5px;
	white-space: normal;
	line-height: 0;
	vertical-align: top;
}
.alice-carousel__prev-btn {
	text-align: right;
	position: absolute;
	top: -8.6rem;
	right: 3rem;
}
.alice-carousel__prev-btn-item {
	display: inline-block;
	cursor: pointer;
	padding: 5px;
	margin: 0;
	color: var(--accent-color);
}
.alice-carousel__next-btn {
	text-align: left;

	position: absolute;
	top: -8.6rem;
	right: 0;
}
.alice-carousel__next-btn-item {
	display: inline-block;
	cursor: pointer;
	padding: 5px;
	margin: 0;
	color: var(--accent-color);
}

.alice-carousel__prev-btn,
.alice-carousel__next-btn {
	display: inline-block;
	box-sizing: border-box;
	padding: 10px 5px;
	font-size: 1rem;
}
.alice-carousel__dots {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	margin: 30px 0 5px;
	padding: 0;
	list-style: none;
	text-align: center;
}
.alice-carousel__dots-item {
	width: 8px;
	height: 8px;
	cursor: pointer;
	border-radius: 50%;
	background-color: var(--pink-color);
}

.alice-carousel__prev-btn [data-area]::after,
.alice-carousel__next-btn [data-area]::after {
	position: relative;
	content: attr(data-area);
	text-transform: capitalize;
}

.alice-carousel__prev-btn-item.__inactive,
.alice-carousel__next-btn-item.__inactive {
	opacity: 0.4;
	pointer-events: none;
}

.alice-carousel__dots-item:not(.__custom):hover,
.alice-carousel__dots-item:not(.__custom).__active {
	background-color: var(--accent-color);
}

.error__svg {
	width: 100px;
	height: 100px;
	fill: var(--red-color);
}

.error__text {
	color: var(--red-color);
	text-align: center;
}

.success__text {
	color: var(--accent-color);
	text-align: center;
}

.text__center{
	text-align: center;
}

:root {
	--accent-color: #875b52;
	--text-color: white;
	--gray-color: #fff9f8;
	--pink-color: #d7bbbb;
	--red-color: #b3261e;

	--color-text: #434141;
	--color-placeholder: rgba(0, 0, 0, 0.5);
	--color-additional: var(--accent-color);
	--color-additional7: rgba(100, 188, 255, 0.7);
	--background-color-calendar: white;
	--background-color-calendar-header: white;
	--alert-bg:var(--red-color)
	--chakra-colors-red-500: var(--red-color);
}

.date__container {
	background-color: var(--background-color-calendar);
	font-size: 15px;
	color: var(--color-text);
	border-radius: 15px;
	padding: 5px 25px;
	margin-bottom: 15px;
}

@media (max-width: 1440px) {
	.block__title {
		font-size: 2.5rem;
	}
}

@media (max-width: 1280px) {
	.block__page {
		padding: 14rem 5rem 6.25rem;
	}
}

@media (max-width: 460px) {
	.block__page {
		padding: 14rem 1.25rem 6.25rem;
	}
	.block__title {
		text-align: center;

		font-size: 2.1875rem;
		font-style: normal;
		font-weight: 600;
		line-height: 100%;

		gap: 0.8rem;
	}

	.block__text{
		font-size: 0.9375rem; 
	}

	.block__page_text {
		gap: 1rem;
	}

	.title__line {
		width: 3.125rem;
		height: 0.0625rem;
	}
	.alice-carousel__prev-btn,
	.alice-carousel__next-btn {
		display: none;
	}
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT;4CAC2C;CAC3C,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,eAAe;CACf,oCAAoC;CACpC,oBAAoB;AACrB;;AAEA;;CAEC,yBAAyB;CAIzB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;CAEC,YAAY;CACZ,aAAa;CACb,oBAAoB;AACrB;;AAEA;;;;CAIC,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mCAAmC;;CAEnC,OAAO;CACP,wBAAwB;CACxB,oBAAoB;CACpB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;;CAEnB,aAAa;CACb,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;;CAEjB,wCAAwC;AACzC;;AAEA;CACC,mCAAmC;;CAEnC,eAAe;CACf,wBAAwB;CACxB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;;;CAGC,aAAa;AACd;AACA;CACC,gCAAgC;CAChC,WAAW;CACX,gBAAgB;CAChB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;;CAE9B,kDAAkD;CAClD,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;CAChC,WAAW;CACX,gBAAgB;CAChB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;;CAE9B,+CAA+C;CAC/C,kBAAkB;AACnB;;AAEA;CACC,+BAA+B;CAC/B,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;;CAEtB,WAAW;;CAEX,mCAAmC;;CAEnC,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,cAAc;;CAEd,2BAA2B,EAAE,eAAe;CAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;CAClD,iBAAiB,EAAE;gFAC4D;AAChF;AACA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,WAAW;CACX,YAAY;CACZ,SAAS;CACT,UAAU;CACV,mBAAmB;CACnB,qBAAqB;CACrB,6BAA6B;CAC7B,2BAA2B;CAC3B,mCAAmC;AACpC;AACA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,UAAU;CACV,SAAS;CACT,sBAAsB;CACtB,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,eAAe;CACf,YAAY;CACZ,SAAS;CACT,0BAA0B;AAC3B;AACA;CACC,gBAAgB;;CAEhB,kBAAkB;CAClB,YAAY;CACZ,QAAQ;AACT;AACA;CACC,qBAAqB;CACrB,eAAe;CACf,YAAY;CACZ,SAAS;CACT,0BAA0B;AAC3B;;AAEA;;CAEC,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;CACT,kBAAkB;CAClB,UAAU;CACV,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,UAAU;CACV,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,mCAAmC;AACpC;;AAEA;;CAEC,kBAAkB;CAClB,wBAAwB;CACxB,0BAA0B;AAC3B;;AAEA;;CAEC,YAAY;CACZ,oBAAoB;AACrB;;AAEA;;CAEC,qCAAqC;AACtC;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,qBAAqB;CACrB,qBAAqB;CACrB,oBAAoB;;CAEpB,qBAAqB;CACrB,uCAAuC;CACvC,uCAAuC;CACvC,6CAA6C;CAC7C,kCAAkC;CAClC,yCAAyC;CACzC;0CACyC;AAC1C;;AAEA;CACC,kDAAkD;CAClD,eAAe;CACf,wBAAwB;CACxB,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,8BAA8B;CAC/B;CACA;EACC,kBAAkB;;EAElB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,WAAW;CACZ;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;;EAEC,aAAa;CACd;AACD","sourcesContent":["body {\n\tmargin: 0;\n\tfont-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',\n\t\t'Droid Sans', 'Helvetica Neue', sans-serif;\n\tfont-size: 16px;\n\toverflow-x: hidden;\n}\n\n* {\n\tbox-sizing: border-box;\n\tfont-size: 16px;\n\tfont-family: 'Noto Sans', sans-serif;\n\tvertical-align: none;\n}\n\nimg,\nsvg {\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\na {\n\ttext-decoration: none;\n}\n\nbutton,\ninput {\n\tborder: none;\n\toutline: none;\n\ttransition: 0.3s all;\n}\n\nh1,\nh2,\nh3,\nh4 {\n\tmargin: 0;\n}\n\n.container {\n\tmargin: 0 10.31rem;\n}\n\n.block__title {\n\tcolor: var(--accent-color, #956446);\n\n\t/* H2 */\n\tfont-family: 'Cormorant';\n\tfont-size: 2.8125rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 1.5rem;\n}\n\n.title__line {\n\twidth: 4.375rem;\n\theight: 0.0925rem;\n\n\tbackground: var(--accent-color, #956446);\n}\n\n.block__text {\n\tcolor: var(--accent-color, #956446);\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.2rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\ntextarea:focus,\ntextarea:active,\ninput:focus {\n\toutline: none;\n}\n.input {\n\tcolor: var(--ui-accent, #875b52);\n\twidth: 100%;\n\tbackground: none;\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n\n\tborder-bottom: 0.0625rem solid var(--accent-color);\n\tpadding: 0.31rem 0;\n}\n\n.input__error {\n\tcolor: var(--ui-accent, #875b52);\n\twidth: 100%;\n\tbackground: none;\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n\n\tborder-bottom: 0.0625rem solid var(--red-color);\n\tpadding: 0.31rem 0;\n}\n\n.block__page {\n\tpadding: 14rem 10.31rem 6.25rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 3.2rem;\n}\n\n.block__page_text {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\n\tgap: 1.5rem;\n\n\tcolor: var(--accent-color, #875b52);\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.dot__list {\n\tmargin-left: 2rem;\n}\n\n.underline__text {\n\ttext-decoration: underline;\n}\n\n.alice-carousel {\n\tposition: relative;\n\twidth: 100%;\n\tmargin: auto;\n\tdirection: ltr;\n\n\t-webkit-touch-callout: none; /* iOS Safari */\n\t-webkit-user-select: none; /* Safari */\n\t-khtml-user-select: none; /* Konqueror HTML */\n\t-moz-user-select: none; /* Old versions of Firefox */\n\t-ms-user-select: none; /* Internet Explorer/Edge */\n\tuser-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n.alice-carousel__stage {\n\tposition: relative;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\tmargin: 0;\n\tpadding: 0;\n\twhite-space: nowrap;\n\ttransform-style: flat;\n\t-webkit-transform-style: flat;\n\tbackface-visibility: hidden;\n\t-webkit-backface-visibility: hidden;\n}\n.alice-carousel__stage-item {\n\tposition: relative;\n\tdisplay: inline-block;\n\tpadding: 0;\n\tmargin: 0;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 5px;\n\twhite-space: normal;\n\tline-height: 0;\n\tvertical-align: top;\n}\n.alice-carousel__prev-btn {\n\ttext-align: right;\n\tposition: absolute;\n\ttop: -8.6rem;\n\tright: 3rem;\n}\n.alice-carousel__prev-btn-item {\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 5px;\n\tmargin: 0;\n\tcolor: var(--accent-color);\n}\n.alice-carousel__next-btn {\n\ttext-align: left;\n\n\tposition: absolute;\n\ttop: -8.6rem;\n\tright: 0;\n}\n.alice-carousel__next-btn-item {\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 5px;\n\tmargin: 0;\n\tcolor: var(--accent-color);\n}\n\n.alice-carousel__prev-btn,\n.alice-carousel__next-btn {\n\tdisplay: inline-block;\n\tbox-sizing: border-box;\n\tpadding: 10px 5px;\n\tfont-size: 1rem;\n}\n.alice-carousel__dots {\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 1rem;\n\tmargin: 30px 0 5px;\n\tpadding: 0;\n\tlist-style: none;\n\ttext-align: center;\n}\n.alice-carousel__dots-item {\n\twidth: 8px;\n\theight: 8px;\n\tcursor: pointer;\n\tborder-radius: 50%;\n\tbackground-color: var(--pink-color);\n}\n\n.alice-carousel__prev-btn [data-area]::after,\n.alice-carousel__next-btn [data-area]::after {\n\tposition: relative;\n\tcontent: attr(data-area);\n\ttext-transform: capitalize;\n}\n\n.alice-carousel__prev-btn-item.__inactive,\n.alice-carousel__next-btn-item.__inactive {\n\topacity: 0.4;\n\tpointer-events: none;\n}\n\n.alice-carousel__dots-item:not(.__custom):hover,\n.alice-carousel__dots-item:not(.__custom).__active {\n\tbackground-color: var(--accent-color);\n}\n\n.error__svg {\n\twidth: 100px;\n\theight: 100px;\n\tfill: var(--red-color);\n}\n\n.error__text {\n\tcolor: var(--red-color);\n\ttext-align: center;\n}\n\n.success__text {\n\tcolor: var(--accent-color);\n\ttext-align: center;\n}\n\n.text__center{\n\ttext-align: center;\n}\n\n:root {\n\t--accent-color: #875b52;\n\t--text-color: white;\n\t--gray-color: #fff9f8;\n\t--pink-color: #d7bbbb;\n\t--red-color: #b3261e;\n\n\t--color-text: #434141;\n\t--color-placeholder: rgba(0, 0, 0, 0.5);\n\t--color-additional: var(--accent-color);\n\t--color-additional7: rgba(100, 188, 255, 0.7);\n\t--background-color-calendar: white;\n\t--background-color-calendar-header: white;\n\t--alert-bg:var(--red-color)\n\t--chakra-colors-red-500: var(--red-color);\n}\n\n.date__container {\n\tbackground-color: var(--background-color-calendar);\n\tfont-size: 15px;\n\tcolor: var(--color-text);\n\tborder-radius: 15px;\n\tpadding: 5px 25px;\n\tmargin-bottom: 15px;\n}\n\n@media (max-width: 1440px) {\n\t.block__title {\n\t\tfont-size: 2.5rem;\n\t}\n}\n\n@media (max-width: 1280px) {\n\t.block__page {\n\t\tpadding: 14rem 5rem 6.25rem;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.block__page {\n\t\tpadding: 14rem 1.25rem 6.25rem;\n\t}\n\t.block__title {\n\t\ttext-align: center;\n\n\t\tfont-size: 2.1875rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%;\n\n\t\tgap: 0.8rem;\n\t}\n\n\t.block__text{\n\t\tfont-size: 0.9375rem; \n\t}\n\n\t.block__page_text {\n\t\tgap: 1rem;\n\t}\n\n\t.title__line {\n\t\twidth: 3.125rem;\n\t\theight: 0.0625rem;\n\t}\n\t.alice-carousel__prev-btn,\n\t.alice-carousel__next-btn {\n\t\tdisplay: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
